
import React from 'react';
import { useMemorial } from '@/contexts/MemorialContext';

export const MemorialMetaTags: React.FC = () => {
  // Component disabled in favor of static meta tags in index.html
  return null;
};
